export default __webpack_public_path__ + "static/media/Group 3.07d4631d.png";